import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useText } from "../context/ContentContext";

export default function Contact() {
  const { t } = useTranslation();
  const lede = useText("contact_lede", "contact.lede");
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = (e) => { e.preventDefault(); setSent(true); setForm({ name: "", email: "", message: "" }); };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div data-testid="contact-page" className="pt-32 md:pt-40 pb-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <div className="overline mb-5">{t("contact.overline")}</div>
          <h1 className="font-serif text-5xl md:text-7xl text-[#F5F5F0] leading-[0.95] mb-10">{t("contact.title")}</h1>
          <p className="text-[#A3A39D] leading-relaxed mb-10 max-w-md">{lede}</p>
          <div className="space-y-6 text-sm text-[#A3A39D]">
            <div>
              <div className="overline text-[10px] mb-1">MAISON AFRA</div>
              <div className="text-[#F5F5F0]">MOUHA LIVRAISON</div>
              53 rue Léonard de Vinci<br />59100 ROUBAIX, France
            </div>
            <div><div className="overline text-[10px] mb-1">SIRET</div>927 618 348 00019</div>
            <div><div className="overline text-[10px] mb-1">Email</div>info@maisonafra.fr</div>
            <div><div className="overline text-[10px] mb-1">Tel</div>+33 1 45 00 00 00</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
          <div>
            <label className="lux-label">{t("contact.name")}</label>
            <input value={form.name} onChange={set("name")} className="lux-input" required data-testid="contact-name" />
          </div>
          <div>
            <label className="lux-label">{t("contact.email")}</label>
            <input type="email" value={form.email} onChange={set("email")} className="lux-input" required data-testid="contact-email" />
          </div>
          <div>
            <label className="lux-label">{t("contact.message")}</label>
            <textarea value={form.message} onChange={set("message")} className="lux-input min-h-[160px]" required data-testid="contact-message" />
          </div>
          <button type="submit" className="btn-primary" data-testid="contact-submit">{t("contact.send")}</button>
          {sent && <div data-testid="contact-success" className="text-sm text-[#D4AF37] border border-[#D4AF37]/40 p-3">{t("contact.success")}</div>}
        </form>
      </div>
    </div>
  );
}
